module.exports = __webpack_public_path__ + "static/media/on.958b528f.svg";